import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { WalletQrCodeAgentMeDto } from "@/features/wallet/api/dto";

/**
 * QR agent de l'appelant (`GET /WalletQrCodes/agent/me`, guide v2.4 §6.3).
 *
 * **Statique** et imprimable (préfixe jeton `A1.`, AES-256-GCM, non tournant) :
 * un agent est un point de vente fixe, pas un client dont la réception tourne.
 * Le client le scanne pour un dépôt espèces (`AGENT_CASH_IN`).
 * Rôles : `flashpay-agents`.
 */
export const useAgentQrMe = (enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_QR_AGENT_ME(),
    queryFn: () =>
      fetchDataGet<WalletQrCodeAgentMeDto>({
        url: walletEndpoints.walletQrCodesExt.agentMe,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
